import React from "react";
import { trustStats } from "../data/content";
export function TrustStrip() {
  return <section className="bg-forest px-4 pb-14 sm:px-6 sm:pb-20" data-id="element-185" data-mp="2o3aqvjxnx1ao">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 border border-moss bg-moss/60 lg:grid-cols-4" data-id="element-186" data-mp="2o5vtwc9p5na0">
        {trustStats.map((s, i) => <div key={s.label} className={`px-3 py-7 text-center sm:py-9 ${i % 2 === 0 ? "border-r border-moss" : ""} ${i < 2 ? "border-b border-moss lg:border-b-0" : ""} ${i === 1 ? "lg:border-r" : ""}`} data-id="element-187" data-mp="2fc0n6zsxfos9" data-mpi={i}>
            <dd className="font-display text-4xl font-bold uppercase text-gold sm:text-5xl" data-id="element-188" data-mp="25c02pajbn2mh">{s.value}</dd>
            <dt className="mt-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-white/80 sm:text-xs" data-id="element-189" data-mp="20ei34ar71zr5">{s.label}</dt>
          </div>)}
      </dl>
    </section>;
}